// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"259":"777633f2","404":"9af50889","685":"4d92679e","791":"e9f7bfe5","822":"2d117c3b"}[chunkId] + ".chunk.js";
};